import {
  fetchDownloadExcel,
  fetchExcelDipos,
  fetchExcelPropViaP,
  fetchExcelMediosImp,
  fetchExcelVisEventos,
  fetchExcelActas,
  fetchExcelHallazgos,
  fetchExcelByMonitoreo,
  fetchExcelCatalogMI,
  fetchExcelCatFechas,
  fetchExcelEnlaces,
  fetchExcelBitacoraSync,
  fetchExcelReporteUsuarios,
  fetchExcelPublicDownloads,
  fetchExcelConfigCatalogos
} from 'services/file.service';
import { generateExcel } from 'utils/excel';
import { get } from 'lodash';
import { showAlert } from './alert.actions';

export const downloadExcelUsr = (data) => async (dispatch) => {
  try {
    const response = await fetchDownloadExcel(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, reponse: error };
  }
};

export const downloadExcelDispos = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelDipos(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelPropViaP = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelPropViaP(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelMediosImp = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelMediosImp(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelVisEventos = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelVisEventos(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

const getExcelHeader = (reportTitle, columnsLength) => [
  [
    {
      value: 'INE',
      type: String,
      fontSize: 28,
      height: 32,
      color: '#DB2491',
      backgroundColor: '#444444',
      alignVertical: 'center',
      align: 'center',
      fontWeight: 'bold'
    },
    ...Array.from(Array(columnsLength - 1)).map(() => ({ height: 32, backgroundColor: '#444444' }))
  ],
  [
    {
      value: reportTitle,
      type: String,
      fontSize: 17,
      height: 32,
      width: 40,
      color: '#FFFFFF',
      backgroundColor: '#888888',
      alignVertical: 'center',
      align: 'center',
      fontWeight: 'bold'
    },
    ...Array.from(Array(columnsLength - 1)).map(() => ({ height: 32, backgroundColor: '#888888' }))
  ]
];

export const generateExcelFromTable = (config) => async (dispatch) => {
  try {
    const { columns: fColumns, usuariosList, options } = config;
    const columns = fColumns.filter((c) => !c.noVisibleInExel);
    const fileData = columns.map((c) => ({
      value: c.rawTitle || c.title,
      type: String,
      backgroundColor: '#CCCCCC'
    }));
    const dd = usuariosList.map((r) => {
      const formatedRow = [];
      columns.forEach((c) => {
        const value = typeof c.dataIndex !== 'string' ? get(r, c.dataIndex, '-') : r[c.dataIndex];
        formatedRow.push({ value, type: String });
      });
      return formatedRow;
    });

    await generateExcel([...getExcelHeader('', columns.length), fileData, ...dd], options);
  } catch (error) {
    console.log(error);
    dispatch(showAlert('Error al generar el archivo excel', 'error'));
  }
};

export const downloadExcelActas = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelActas(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelHallazgos = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelHallazgos(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelMonitoreos = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelByMonitoreo(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelCatalogoMI = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelCatalogMI(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelCatFechas = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelCatFechas(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelEnlaces = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelEnlaces(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelBitacoraSync = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelBitacoraSync(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelReporteUsuarios = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelReporteUsuarios(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelPublicDowloads = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelPublicDownloads(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};

export const downloadExcelConfiguracionCatalogos = (data) => async (dispatch) => {
  try {
    const response = await fetchExcelConfigCatalogos(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};
